// @flow
import { event } from "../../utils/events";

import { fetchUserInfo as fetchUserInfoService } from "../../rest/user-context";
import { fetchSessionInfo as fetchSessionInfoService } from "../../rest/session-context";

export const FETCH_USER_INFO_SUCCESS = "state.context.FETCH_USER_INFO_SUCCESS";
export const FETCH_USER_INFO_ERROR = "state.context.FETCH_USER_INFO_ERROR";
export const FETCH_SESSION_INFO_SUCCESS = "state.context.FETCH_SESSION_INFO_SUCCESS";
export const FETCH_SESSION_INFO_ERROR = "state.context.FETCH_SESSION_INFO_ERROR";
export const DISMISS_ERROR_FLAG = "state.context.DISMISS_ERROR_FLAG";
export const DISMISS_SUCCESS_FLAG = "state.context.DISMISS_SUCCESS_FLAG";
export const SHOW_DIALOG = "state.context.SHOW_DIALOG";
export const HIDE_DIALOG = "state.context.HIDE_DIALOG";

export const fetchUserInfo = blogPassword => async dispatch => {
    try {
        const userInfo = await fetchUserInfoService(blogPassword);
        dispatch({ type: FETCH_USER_INFO_SUCCESS, payload: userInfo });
    } catch (e) {
        dispatch({ type: FETCH_USER_INFO_ERROR, payload: e });
        console.log(e);
    }
};

export const fetchSessionInfo = () => async dispatch => {
    try {
        const sessionInfo = await fetchSessionInfoService();
        dispatch({ type: FETCH_SESSION_INFO_SUCCESS, payload: sessionInfo });
    } catch (e) {
        dispatch({ type: FETCH_SESSION_INFO_ERROR, payload: e });
        console.log(e);
    }
};

export const showDialog = dialogName => async dispatch => {
    event({
        category: `Open dialog`,
        action: dialogName
    });

    dispatch({ type: SHOW_DIALOG, payload: dialogName });
};

export const hideDialog = dialogName => async dispatch => {
    event({
        category: `Close dialog`,
        action: dialogName
    });
    dispatch({ type: HIDE_DIALOG, payload: dialogName });
};

export const dismissErrorFlag = () => ({
    type: DISMISS_ERROR_FLAG
});

export const dismissSuccessFlag = () => ({
    type: DISMISS_SUCCESS_FLAG
});

export const reloadPage = () => () => {
    window.location.reload(true);
};



// WEBPACK FOOTER //
// ./src/state/context/actions.js